import { useHistory, useLocation } from "react-router-dom";
import StarRatings from "react-star-ratings";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Skeleton, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import * as Styles from "./Start.styles";
import * as AwardStyles from "pages/healthAnalyse-Plan2/Challenge/Challenge.styles";
import FoodiaryKrankenkassen from "assets/images/health-analyse/Foodiary-Krankenkassen.jpg";
import FoodIconOne from "assets/images/Aok-Foodiary-1.jpg";
import FoodIconTwo from "assets/images/Barmer-Foodiary.jpg";
import FoodIconThree from "assets/images/Bkk-Foodiary.jpg";
import FoodIconFour from "assets/images/DAK-foodiary-1.jpg";
import FoodIconFive from "assets/images/mhplus-foodiary.jpg";
import MainHeader from "../../../components/Wrapper/HealthAnalyseHeader";
import { ERNAEHRUNGSFORM } from "routes/routes";
import * as AuthActions from "redux/auth/auth.actions";
import ApiCollections from "configs/services/apiCollections";
import * as CoachActions from "redux/coach/coach.actions";
import { IMG_BASE_URL } from "pages/selectCoach/selectCoach";
import AwardImage from "assets/images/health-analyse/award.png";

function Start() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const eid = params.get("EID");
  const tid = params.get("TID");
  const fid = params.get("FID");
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState(false);
  const { trainerShowData, registrationData, loading } = useSelector(
    (state) => state.auth
  );

  const trainersDataRef = useRef({});

  const history = useHistory();
  const handleResize = () => {
    if (window.innerWidth < 900) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };
  useEffect(() => {
    document.body.classList.add("app-register");
    if (window.innerWidth < 600) {
      setIsMobile(true);
    }
    window.addEventListener("resize", handleResize);
    return () => {
      document.body.classList.remove("app-register");
    };
  }, []);
  useEffect(() => {
    if (eid && tid && fid) {
      const data = {
        name: "unknwon",
        email: eid,
      };

      ApiCollections.getNutritionConceptToken(data)
        .then((response) => {
          const data = {
            grant_type: "password",
            client_id: 2,
            client_secret: process.env.REACT_APP_CLIENT_SECRET,
            trainerID: tid,
            FranchiseID: fid,
            nutritionconcept_token:
              response?.data?.data?.nutritionconcept_token,
          };
          dispatch(
            AuthActions.signInExistingPlanRequest({
              formData: data,
              func: (res) => {
                trainersDataRef.current = res.data?.userData;
                dispatch(AuthActions.saveTrainerToken(res.data?.token));

                const data = {
                  trainerID: tid,
                  FranchiseID: fid,
                };
                dispatch(
                  AuthActions.trainerShowData({
                    data,
                    callback: () => {
                      fetchNutritionData();
                    },
                  })
                );
              },
            })
          );
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, []);

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 40, color: "#2ECF96" }} spin />
  );

  const handleBtnClick = () => {
    history.push(ERNAEHRUNGSFORM);
  };

  const fetchNutritionData = () => {
    const apiCalls = [
      ApiCollections.nutritionTypeShow({
        nutritiontypeID: trainersDataRef?.current?.nutritiontypeID,
        aimID: trainersDataRef?.current?.aimID,
        sex: trainersDataRef?.current?.sex,
      }),

      ApiCollections.nutritionTypeList({
        aimID: trainersDataRef?.current?.aimID,
        sex: trainersDataRef?.current?.sex,
      }),

      ApiCollections.nutritionTypeAdvantagesData({
        nutritiontypeID: trainersDataRef?.current?.nutritiontypeID,
        aimID: trainersDataRef?.current?.aimID,
        sex: trainersDataRef?.current?.sex,
      }),

      ApiCollections.nutritionTypeRecipeData({
        nutritiontypeID: trainersDataRef?.current?.nutritiontypeID,
        mealId: 1,
      }),

      ApiCollections.nutritionTypeWeekWiseData({
        nutritiontypeID: trainersDataRef?.current?.nutritiontypeID,
        aimID: trainersDataRef?.current?.aimID,
        sex: trainersDataRef?.current?.sex,
        user_id: trainersDataRef?.current?.userID,
      }),

      // Pie chart data
      ApiCollections.nutritionTypePieChartData({
        nutritiontypeID: trainersDataRef?.current?.nutritiontypeID,
      }),
    ];

    Promise.allSettled(apiCalls)
      .then((results) => {
        const dataContainer = {
          nutritionTypeData: null,
          nutritionTypeList: null,
          advantagesData: null,
          recipeData: null,
          weekWiseData: null,
          pieChartData: null,
        };

        results.forEach((result, index) => {
          if (result.status === "fulfilled") {
            const response = result.value;

            switch (index) {
              case 0:
                dataContainer.nutritionTypeData = response?.data;
                break;
              case 1:
                dataContainer.nutritionTypeList = response?.data;
                break;
              case 2:
                dataContainer.advantagesData = response?.data;
                break;
              case 3:
                dataContainer.recipeData = response?.data;
                break;
              case 4:
                dataContainer.weekWiseData = response?.data;
                break;
              case 5:
                dataContainer.pieChartData = {
                  nutritiontype: response?.nutritiontype,
                  pieChartData: response?.pieChartData,
                };
                break;
              default:
                break;
            }
          } else {
            console.error(`API call ${index} failed:`, result.reason);
          }
        });

        dispatch(CoachActions.saveAllNutritionsData(dataContainer));
      })
      .catch((error) => {
        console.error("Unexpected error in data fetching process:", error);
      });
  };

  return (
    // <Spin
    //   spinning={isLoading}
    //   indicator={antIcon}
    //   tip="Loading..."
    //   size="large"
    //   wrapperClassName="nutrition-data-loader"
    // >
    <Styles.MainContainer>
      <div className="main-div">
        <MainHeader
          headline={"Ernährungsplan"}
          subHeadline={"Ich bin dein Coach!"}
          handleNextPage={handleBtnClick}
          noBackButton={true}
        />
        <Styles.Container>
          <Styles.TopContent>
            <h3>
              Ich habe deinen Ernährungsplan und deine Unterstützung
              fertiggestellt.
            </h3>
            <p>
              Mit Foodiary wird deine Ernährungsumstellung zum Kinderspiel! Wir
              helfen dir dabei, dein Wunschgewicht zu erreichen und ein gesundes
              Leben voller Energie und Selbstbewusstsein zu führen.
            </p>
          </Styles.TopContent>
          <Styles.CoachCard>
            {loading ? (
              <Skeleton.Image
                active={true}
                style={{
                  width: isMobile ? 100 : 160,
                  height: isMobile ? 100 : "100%",
                  marginRight: 20,
                  borderRadius: 15,
                }}
              />
            ) : (
              <Styles.CoachImage>
                <img
                  src={IMG_BASE_URL + trainerShowData?.profilePic}
                  alt="Felix Mergenthaler"
                />
              </Styles.CoachImage>
            )}
            <Styles.CoachInfo>
              <Styles.CoachLabel>Dein Coach:</Styles.CoachLabel>
              <Styles.CoachName>
                {trainerShowData?.prename} {trainerShowData?.surname}
              </Styles.CoachName>
              <Styles.RatingContainer>
                <StarRatings
                  rating={5}
                  starRatedColor="#FFC400"
                  numberOfStars={5}
                  starDimension="14px"
                  starSpacing="1px"
                />
                <Styles.Reviews>
                  50.000 Ernährungspläne durch Foodiary erstellt
                </Styles.Reviews>
              </Styles.RatingContainer>
              <Styles.DesktopCredentialsContainer>
                <Styles.CredentialItem hasBorder={true}>
                  <Styles.CredentialLabel>Ausbildungen:</Styles.CredentialLabel>
                  <Styles.CredentialValue>
                    {trainerShowData?.step3}
                  </Styles.CredentialValue>
                </Styles.CredentialItem>
                <Styles.CredentialItem hasBorder={true}>
                  <Styles.CredentialLabel>Coach für:</Styles.CredentialLabel>
                  <Styles.CredentialValue>
                    {trainerShowData?.subtitle}
                  </Styles.CredentialValue>
                </Styles.CredentialItem>
                <Styles.CredentialItem>
                  <Styles.CredentialLabel>Coach seit:</Styles.CredentialLabel>
                  <Styles.CredentialValue>
                    {trainerShowData?.step2}
                  </Styles.CredentialValue>
                </Styles.CredentialItem>
              </Styles.DesktopCredentialsContainer>
            </Styles.CoachInfo>
          </Styles.CoachCard>

          <Styles.MobileCredentialsContainer>
            <Styles.CredentialItem hasBorder={true}>
              <Styles.CredentialLabel>Ausbildungen:</Styles.CredentialLabel>
              <Styles.CredentialValue>
                {trainerShowData?.step3}
              </Styles.CredentialValue>
            </Styles.CredentialItem>
            <Styles.CredentialItem hasBorder={true}>
              <Styles.CredentialLabel>Coach für:</Styles.CredentialLabel>
              <Styles.CredentialValue>
                {trainerShowData?.subtitle}
              </Styles.CredentialValue>
            </Styles.CredentialItem>
            <Styles.CredentialItem>
              <Styles.CredentialLabel>Coach seit:</Styles.CredentialLabel>
              <Styles.CredentialValue>
                {" "}
                {trainerShowData?.step2}
              </Styles.CredentialValue>
            </Styles.CredentialItem>
          </Styles.MobileCredentialsContainer>

          <Styles.MessageBox>
            <Styles.MessageTitle>
              Wir erreichen gemeinsam dein Ziel!
            </Styles.MessageTitle>
            <Styles.MessageText>
              Hey {registrationData?.prename},
              <br />
              dein individueller Ernährungsplan ist fertig - abgestimmt auf dein
              Ziel, Ich zeig dir alles in Ruhe, und dann legen wir zusammen los!
            </Styles.MessageText>
          </Styles.MessageBox>
          <div className="award-section">
            <AwardStyles.AwardSection>
              <div className="award-container">
                <img src={AwardImage} alt="Award" className="award-icon" />
                <div className="content-column">
                  <p className="title">Gesunde Gewohnheiten</p>
                  <p className="subtitle">12 Wochen Health Challenge</p>
                  <p className="description">Starten und gewinnen</p>
                </div>
              </div>

              <h3 className="amount">1.000 €</h3>
            </AwardStyles.AwardSection>
          </div>
          <InsuranceSection />
        </Styles.Container>
      </div>
      <button
        onClick={handleBtnClick}
        className="btn-dark w-full mt-8 btn-show"
        // disabled={isLoading}
      >
        Ernährungsplan ansehen
      </button>
    </Styles.MainContainer>
    // </Spin>
  );
}

export default Start;

export const InsuranceSection = ({
  notTitle = false,
  title = "100% Kostenübernahme durch deine gesetzliche Krankenkasse:",
}) => {
  const handleClick = () =>
    window.open(
      "https://partner.foodiary.app/data/zertifikat_KU-ER-8GDL3M.pdf",
      "_blank"
    );
  return (
    <Styles.InsuranceSection>
      {!notTitle && <Styles.InsuranceTitle>{title}</Styles.InsuranceTitle>}
      <Styles.MobileGrid>
        <img src={FoodiaryKrankenkassen} alt="AOK" />
      </Styles.MobileGrid>
      <Styles.DesktopGrid>
        <img src={FoodIconOne} alt="AOK" />
        <img src={FoodIconTwo} alt="AOK" />
        <img src={FoodIconThree} alt="DAK Gesundheit" />
        <img src={FoodIconFour} alt="IST Studieninstitut" />
        <img src={FoodIconFive} alt="IST Studieninstitut" />
      </Styles.DesktopGrid>

      <Styles.CertificateButton onClick={handleClick}>
        Zertifikat anzeigen
      </Styles.CertificateButton>
    </Styles.InsuranceSection>
  );
};
